import { apiClient } from './apiClient';

export const twoFactorService = {
  /**
   * Generate 2FA secret and get QR code URL
   */
  async setup() {
    return apiClient.post('/api/users/me/2fa/setup');
  },

  /**
   * Verify code and enable 2FA
   * @param {string} code - 6-digit verification code
   */
  async enable(code) {
    return apiClient.post('/api/users/me/2fa/enable', { code });
  },

  /**
   * Verify code and disable 2FA
   * @param {string} code - 6-digit verification code
   */
  async disable(code) {
    return apiClient.post('/api/users/me/2fa/disable', { code });
  },
};
